export default {
  addedSet(state) {
    return state.addedSet;
  },
};
